const config = {
  recaptcha: {
    // dev
    // siteKey: "6LcLU8AfAAAAAN1xFdKPOfoNLtBz3VQRP9O6gPbN",
    // production
    siteKey: "6LfOUcAfAAAAAGUbQwQiDkXuKzEK-zooPzFML_lx",
  },
  // production
  baseUrl: "https://anagnorisis.qcast.io",
  // dev
  // baseUrl: "https://staging.qcast.io",
  // editBaseUrl: "http://localhost:5000",
  editBaseUrl: "https://fierce-nostalgic-roundworm.glitch.me",
};

export default config;
